import { QuestionPlanStockTarget as Question } from "@/components/features/items/edit/plan/_shared/ui/components/stock/stock-target";

import { useDayTripPlanStockTarget } from "./hooks";

export const QuestionDayTripPlanStockTarget = () => {
	const { maxDailyStockNum, stockTypeTarget, onSetMaxDailyStockNum, onSetStockTypeTarget, isEdited, hasError } =
		useDayTripPlanStockTarget();

	return (
		<Question
			maxDailyStockNum={maxDailyStockNum}
			stockTypeTarget={stockTypeTarget}
			onSetMaxDailyStockNum={onSetMaxDailyStockNum}
			onSetStockTypeTarget={onSetStockTypeTarget}
			isEdited={isEdited}
			hasError={hasError}
		/>
	);
};
